module.exports = __webpack_public_path__ + "img/maitian-bg.37ceee85.jpg";